import React from "react";
import logo from "../assets/images/careconnect.jpg";
import ToggleButton from "../components/ToggleButton.tsx";
import { useTheme } from "../context/ThemeContext.js";
import { IoIosMenu } from "react-icons/io";
export default function Header({ pageTitle, toggleSidebar }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="navbar">
      <button className="navbar__toggle" onClick={toggleSidebar}>
        <IoIosMenu size={30} />
      </button>
      <div className="navbar__logo">
        <img src={logo} alt="Logo" />
      </div>
      <div className="navbar__main">
        <h3 className="navbar__title">{pageTitle}</h3>
        <div
          style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}
        >
          <p
            className="template__details-item-name"
            style={{ margin: 0, marginRight: "10px" }}
          >
            Light
          </p>
          <ToggleButton onToggle={toggleTheme} initialValue={theme === "dark"} />
          <p
            className="template__details-item-name"
            style={{ margin: 0, marginLeft: "10px" }}
          >
            Dark
          </p>
        </div>
      </div>
    </div>
  );
}
